import Image from 'next/image'

interface OorvaLogoProps {
  className?: string;
  showText?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '3xl' | 'banner';
}

const sizes = {
  sm: 'h-10 w-24',
  md: 'h-12 w-32',
  lg: 'h-16 w-40',
  xl: 'h-20 w-48',
  '3xl': 'h-32 w-80',
  banner: 'h-16 w-40 md:h-20 md:w-48',
};

export function OorvaLogo({ className = "", size = 'md' }: OorvaLogoProps) {
  return (
    <div className={`flex items-center ${className}`}>
      <div className={`relative ${sizes[size]}`}>
        <Image
          src="/oorva-new-logo.png"
          alt="Oorva"
          fill
          sizes="(min-width: 768px) 192px, 160px"
          priority
          className="object-contain"
        />
      </div>
    </div>
  );
}
